import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import {
  MatMomentDateModule,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatLegacyListModule as MatListModule} from '@angular/material/legacy-list';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {MatSortModule} from '@angular/material/sort';
import {MatBadgeModule} from '@angular/material/badge';
import {MatMenuModule} from '@angular/material/menu';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTabsModule} from '@angular/material/tabs';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatChipsModule} from '@angular/material/chips';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {FormsModule} from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatListModule,
        MatExpansionModule,
        MatSidenavModule,
        MatProgressBarModule,
        MatCardModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        MatInputModule,
        MatSnackBarModule,
        MatTableModule,
        MatTooltipModule,
        MatSelectModule,
        MatSortModule,
        MatBadgeModule,
        MatMenuModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        DragDropModule,
        MatTabsModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatButtonToggleModule,
        FormsModule,
        MatRadioModule,
        MatMomentDateModule,
        MatDialogModule
    ],
    exports: [
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatListModule,
        MatExpansionModule,
        MatSidenavModule,
        MatProgressBarModule,
        MatCardModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        MatInputModule,
        MatSnackBarModule,
        MatTableModule,
        MatTooltipModule,
        MatSelectModule,
        MatSortModule,
        MatBadgeModule,
        MatMenuModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        DragDropModule,
        MatTabsModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatButtonToggleModule,
        FormsModule,
        MatRadioModule,
        MatMomentDateModule,
        MatDialogModule
    ],
    providers: [
      {provide: MAT_DATE_LOCALE, useValue: 'fr'},
      {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}
  ]
})
export class MaterialModule { }
